export default __webpack_public_path__ + "static/media/old_logo.0eb0853c.svg";